import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=8e5d0f68&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=8e5d0f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d0f68",
  null
  
)

export default component.exports